import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SessionSlideModel } from "../../object-actions/types/types";
import YouTubeModal from "./YouTubeModal";

interface YouTubeCTAProps {
    slide: SessionSlideModel;
}

const YouTubeCTA: React.FC<YouTubeCTAProps> = ({ slide }) => {
    const [searchParams] = useSearchParams();

    // Dev backdoor: reopen the modal on reload when the URL targets this slide.
    const [open, setOpen] = useState(
        () => searchParams.get("yt") === "1" && searchParams.get("yts") === String(slide.id)
    );

    if (!slide.media_search_query?.trim()) {
        return null;
    }

    return (
        <Box sx={{ mt: 2 }}>
            <Button
                variant="outlined"
                startIcon={<SmartDisplayIcon />}
                onClick={() => setOpen(true)}
                data-attr="youtube_open-modal"
                data-custom-id={slide.id}
                data-testid="youtube-cta"
            >
                Find an inspiring video
            </Button>

            {open && (
                <YouTubeModal open={open} onClose={() => setOpen(false)} slide={slide} />
            )}
        </Box>
    );
};

export default YouTubeCTA;
